/**
 * Returns a date formatted as string to a specific locale
 * @param date - Date to format (can be a string or a timestamp too)
 * @param locale - Locale used to format locally the date
 * @param options - Formatting options for the date
 * @returns date formatted as string
 */
export function getLocaleDate(
  date: Date | string | number | undefined,
  locale: string,
  options?: Intl.DateTimeFormatOptions
): string {
  return date
    ? new Date(date).toLocaleDateString(locale, {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        ...options,
      })
    : '';
}
